<template>
  <div class="row">
    <div class="col-xl-12 d-flex">
      <div class="card flex-fill">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-2">
          <h5>Recent Leads</h5>
          <router-link to="/crm/leads-list" class="btn btn-sm btn-light px-3">View All</router-link>
        </div>

        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-nowrap dashboard-table mb-0">
              <thead>
                <tr>
                  <th>Lead Name</th>
                  <th>Company Name</th>
                  <th>Stage</th>
                  <th>Created Date</th>
                  <th>Lead Owner</th>
                </tr>
              </thead>

              <tbody>
                <tr v-if="loading">
                  <td colspan="5" class="p-4">
                    <div class="placeholder-glow">
                      <div class="placeholder col-12 mb-2"></div>
                      <div class="placeholder col-10"></div>
                    </div>
                  </td>
                </tr>

                <tr
                  v-for="l in rows"
                  :key="l.id"
                  class="hover-pointer"
                  @click="goLead(l.id)"
                >
                  <td>
                    <h6 class="fw-medium mb-0">{{ l.name || "—" }}</h6>
                  </td>

                  <td>
                    <div class="d-flex align-items-center file-name-icon">
                      <span class="avatar border rounded-circle bg-gray-100 d-flex align-items-center justify-content-center">
                        <i class="ti ti-building"></i>
                      </span>
                      <div class="ms-2">
                        <h6 class="fw-medium mb-0">{{ l.company_name || "—" }}</h6>
                      </div>
                    </div>
                  </td>

                  <td>
                    <span class="badge badge-secondary d-inline-flex align-items-center">
                      <i class="ti ti-point-filled me-1"></i>{{ l.stage?.name || "Unassigned" }}
                    </span>
                  </td>

                  <td>{{ l.created_at ? formatDate(l.created_at) : "—" }}</td>

                  <td @click.stop="drillOwner(l.owner?.id)">
                    {{ ownerName(l) }}
                  </td>
                </tr>

                <tr v-if="!loading && !rows.length">
                  <td colspan="5" class="text-center text-muted py-4">
                    No recent leads for selected filters.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useLeadDashboardStore } from "@/stores/leadDashboardStore";

const dash = useLeadDashboardStore();
const router = useRouter();

const loading = computed(() => dash.loading);
const rows = computed(() => Array.isArray(dash.recentLeads) ? dash.recentLeads : []);

function ownerName(l) {
  const o = l?.owner;
  if (!o) return "—";
  return `${o.first_name || ""} ${o.last_name || ""}`.trim() || "—";
}

function formatDate(dt) {
  // dt usually ISO
  const d = new Date(dt);
  if (Number.isNaN(d.getTime())) return dt;
  return d.toLocaleDateString();
}

function goLead(id) {
  // adjust if your router uses a different path
  router.push(`/crm/leads-details/${id}`);
}

async function drillOwner(ownerId) {
  if (!ownerId) return;
  dash.filters.owner_id = ownerId;
  await dash.fetchDashboard();
}
</script>

<style scoped>
.hover-pointer { cursor: pointer; }
</style>
